/**
 * User
 * @returns JSON
 */
export async function user() {
  var myHeaders = new Headers()
  myHeaders.append('Authorization', `Bearer ${localStorage.getItem('AccessToken')}`)

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}user`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to provinces', { status: 500 })
  }
  return response.json()
}

export async function signIn(post) {
  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')

  var raw = JSON.stringify(post)

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}signIn`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to ', { status: 500 })
  }

  return response.json()
}
export async function link(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}link/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}link`)
  }
  if (!response.ok) {
    throw new Response('Fails to fetch data', { status: 500 })
  }
  return response.json()
}
export async function getLinks(page) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}links/${page}`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getPrayer(page) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}prayer/${page}`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getMuharramTeshtgozari() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharram_teshtgozari`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}

export async function getMuharramVoice() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharram_voice`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getMuharramChildren() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharram_children`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getMuharramCalendar() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharram_calendar`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}

export async function getMosque() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}mosque`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getMuharramWelcome(year) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharram_welcome/${year}`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}

export async function getQuran() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}quran`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getMuharramContent() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharram_content`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}

export async function getMuharramPresentOrder() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharram_present_order`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}

export async function getPrayerContent(id) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}prayerContent/${id}`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getPrayerVideo() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}prayerVideo`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function getMuharramDasteh() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}muharramDasteh`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}
export async function allLink() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}allLink`)
  if (!response.ok) throw new Response('Fails to fetch data', { status: 500 })
  return response.json()
}

export async function broadcast() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}broadcast`)
  if (!response.ok) {
    throw new Response('Failed to fetch broadcast', { status: 500 })
  }
  return response.json()
}

export async function getStatistics() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}statistics`)
  if (!response.ok) {
    throw new Response('Failed to fetch statistics', { status: 500 })
  }
  return response.json()
}
export async function getRegions() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}regions`)
  if (!response.ok) {
    throw new Response('Failed to fetch statistics', { status: 500 })
  }
  return response.json()
}
export async function configi() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}config`)
  if (!response.ok) {
    throw new Response('Failed to fetch config', { status: 500 })
  }
  return response.json()
}
export async function getContent() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}content`)
  if (!response.ok) {
    throw new Response('Failed to fetch config', { status: 500 })
  }
  return response.json()
}
export async function billboard() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}billboard`)
  if (!response.ok) {
    throw new Response('Failed to fetch billboard', { status: 500 })
  }
  return response.json()
}
export async function airquality() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}airquality`)

  if (!response.ok) {
    throw new Response('Failed to fetch airquality', { status: 500 })
  }
  return response.json()
}
export async function transportation(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}transportation/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}transportation`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch transportation', { status: 500 })
  }
  return response.json()
}

export async function city(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}city/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}city`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch city', { status: 500 })
  }
  return response.json()
}

export async function software(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}software/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}software`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch software', { status: 500 })
  }
  return response.json()
}

export async function vehicle(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}vehicle/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}vehicle`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch city', { status: 500 })
  }
  return response.json()
}

export async function getParking() {
  let response = await fetch(`https://api.ardabilman.ir/v1/getParking`)
  if (!response.ok) {
    throw new Response('Failed to fetch parking', { status: 500 })
  }
  return response.json()
}

export async function getTourismLink(path) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}tourismLink?path=${path}`)
  if (!response.ok) throw new Response('Failed to fetch city', { status: 500 })
  return response.json()
}

export async function getPages(id) {
  let response
  if (id) response = await fetch(`${process.env.REACT_APP_BASE_URL}pages/${id}`)
  else response = await fetch(`${process.env.REACT_APP_BASE_URL}pages`)
  if (!response.ok) {
    throw new Response('Failed to fetch city', { status: 500 })
  }
  return response.json()
}

export async function getState(id) {
  let response
  if (id) response = await fetch(`${process.env.REACT_APP_BASE_URL}state/${id}`)
  else response = await fetch(`${process.env.REACT_APP_BASE_URL}state`)
  if (!response.ok) {
    throw new Response('Failed to fetch city', { status: 500 })
  }
  return response.json()
}

export async function getStateCity(id) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}stateCity/${id}`)
  if (!response.ok) {
    throw new Response('Failed to fetch city', { status: 500 })
  }
  return response.json()
}

export async function getCityDetail(id) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}cityDetail/${id}`)
  if (!response.ok) {
    throw new Response('Failed to fetch city', { status: 500 })
  }
  return response.json()
}

export async function gallery(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}gallery/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}gallery`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch gallery', { status: 500 })
  }
  return response.json()
}
export async function subscription(res) {
  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  console.log(res)
  var raw = JSON.stringify(res)

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}subscription`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to provinces', { status: 500 })
  }
  return response.json()
}

export async function getCourseContent() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}courseContent`)
  if (!response.ok) {
    throw new Response('Failed to fetch city', { status: 500 })
  }
  return response.json()
}
/**
 * Submit Course Sport
 * @param {*} res
 * @returns
 */
export async function submitCourseSport(res) {
  //var raw = JSON.stringify(file)

  var requestOptions = {
    method: 'POST',
    body: res,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}submitCourseSport`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed idea submission', { status: 500 })
  }
  return response.json()
}

/**
 * Submit Course Sport
 * @param {*} res
 * @returns
 */
export async function submitCourseEducation(res) {
  //var raw = JSON.stringify(file)

  var requestOptions = {
    method: 'POST',
    body: res,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}submitCourseEducation`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed idea submission', { status: 500 })
  }
  return response.json()
}

/**
 * Submit Course Sport
 * @param {*} res
 * @returns
 */
export async function submitCourseCulture(res) {
  //var raw = JSON.stringify(file)

  var requestOptions = {
    method: 'POST',
    body: res,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}submitCourseCulture`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed idea submission', { status: 500 })
  }
  return response.json()
}
/**
 * Submit Idea
 * @param {*} res
 * @returns
 */
export async function submitIdea(res) {
  //var raw = JSON.stringify(file)

  var requestOptions = {
    method: 'POST',
    body: res,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}submitIdea`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed idea submission', { status: 500 })
  }
  return response.json()
}

export async function sso(code) {
  console.log(code)

  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')

  var raw = JSON.stringify(code)

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}sso`, requestOptions)
  if (!response.ok) throw new Response('Failed sso', { status: 500 })
  return response.json()
}

export async function newUsr(data, mobile) {
  console.log(data)

  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')

  var raw = JSON.stringify(data)

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL}newUsr/${mobile}`, requestOptions)
  if (!response.ok) throw new Response('Failed sso', { status: 500 })
  return response.json()
}

export async function advertisment(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}advertisment/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}advertisment`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch gallery', { status: 500 })
  }
  return response.json()
}

export async function project(id) {
  let response
  if (id) response = await fetch(`${process.env.REACT_APP_BASE_URL}project/${id}`)
  else response = await fetch(`${process.env.REACT_APP_BASE_URL}project`)
  if (!response.ok) throw new Response('Failed to fetch gallery', { status: 500 })
  return response.json()
}

export async function parking() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}parking`)
  if (!response.ok) throw new Response('Failed to fetch parking', { status: 500 })
  return response.json()
}

export async function book(id) {
  let response
  if (id) response = await fetch(`${process.env.REACT_APP_BASE_URL}book/${id}`)
  else response = await fetch(`${process.env.REACT_APP_BASE_URL}book`)
  if (!response.ok) throw new Response('Failed to fetch book', { status: 500 })
  return response.json()
}
export async function event(id) {
  let response
  if (id) response = await fetch(`${process.env.REACT_APP_BASE_URL}event/${id}`)
  else response = await fetch(`${process.env.REACT_APP_BASE_URL}event`)
  if (!response.ok) throw new Response('Failed to fetch gallery', { status: 500 })
  return response.json()
}

// Course
export async function courseCost() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}courseCost`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}

export async function eventidea(page) {
  let response
  if (page) response = await fetch(`${process.env.REACT_APP_BASE_URL}eventidea/${page}`)
  if (!response.ok) throw new Response('Failed to fetch gallery', { status: 500 })
  return response.json()
}

export async function ideaCategory(page) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}ideaCategory/${page}`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}
export async function ideaCategory2(page) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}ideaCategory2/${page}`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}

export async function getEducationlevel() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}educationlevel`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}

/**
 * Farhangsara
 * @returns object
 */
export async function getFarhangsara() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}farhangsara`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}

export async function getSocial() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}social`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}

export async function getPlan() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}plan`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}


export async function getNeshat() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL}neshat`)

  if (!response.ok) {
    throw new Response('Failed to fetch idea category', { status: 500 })
  }
  return response.json()
}

export async function sharelink(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}sharelink/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}sharelink`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch gallery', { status: 500 })
  }
  return response.json()
}

export async function tel(linkId) {
  let response
  if (linkId) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}tel/${linkId}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}tel`)
  }
  if (!response.ok) {
    throw new Response('Failed to fetch gallery', { status: 500 })
  }
  return response.json()
}
export async function vr(id) {
  let response
  if (id) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}vr/${id}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}vr`)
  }
  if (!response.ok) {
    throw new Response('Fails to fetch data', { status: 500 })
  }
  return response.json()
}

export async function gis(id) {
  let response
  if (id) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}point/${id}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}point`)
  }
  if (!response.ok) {
    throw new Response('Fails to fetch data', { status: 500 })
  }
  return response.json()
}

export async function layer(id) {
  let response
  if (id) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}layer/${id}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}layer`)
  }
  if (!response.ok) {
    throw new Response('Fails to fetch data', { status: 500 })
  }
  return response.json()
}

export async function pantheon(id) {
  let response
  if (id) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}pantheon/${id}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}pantheon`)
  }
  if (!response.ok) {
    throw new Response('Fails to fetch data', { status: 500 })
  }
  return response.json()
}

export async function education(id) {
  let response
  if (id) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}education/${id}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}education`)
  }
  if (!response.ok) {
    throw new Response('Fails to fetch data', { status: 500 })
  }
  return response.json()
}

export async function citizenshipEducation(id) {
  let response
  if (id) {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}citizenshipEducation/${id}`)
  } else {
    response = await fetch(`${process.env.REACT_APP_BASE_URL}citizenshipEducation`)
  }
  if (!response.ok) {
    throw new Response('Fails to fetch data', { status: 500 })
  }
  return response.json()
}
